import { CSSObject } from "@emotion/react";

export const directionsLabel: CSSObject = {
  display: "block",
  fontWeight: "bold",
  marginTop: "10px",
};

export const directionsTextareaCssWrapper: CSSObject = {
  margin: "0 0 10px",
};

export const textareaCss: CSSObject = {
  height: "54px",
};

export const paragraphCss: CSSObject = {
  height: "54px",
};
